import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "publish",
  "use": "publish-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"publish\"><path d=\"M6.607 13.543V11.88c0-.886-.718-1.605-1.605-1.605a.605.605 0 01-.418-1.042l2.888-2.764a2.21 2.21 0 013.056 0l2.888 2.764a.605.605 0 01-.418 1.042c-.887 0-1.605.719-1.605 1.605v1.664a2.27 2.27 0 01-2.27 2.27h-.247a2.27 2.27 0 01-2.269-2.27z\" /><rect x=\"3\" y=\".75\" width=\"12\" height=\"2.25\" rx=\"1.125\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol